import axiosInstance from '../config/axios';

/**
 * Fetch user earnings and payouts
 * @param {object} params Optional pagination or filtering parameters (e.g. page, limit)
 */
export const getEarningsApi = async (params = {}) => {
  try {
    const res = await axiosInstance.get('/get-earnings', { params });
    return res.data;
  } catch (error) {
    console.error("Error fetching earnings:", error);
    throw error;
  }
};

